
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Tabs, Tab, Paper
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { set } from 'lodash';
// import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { ToolBar } from '../../components/toolbar';
import { Modal } from '../../components/modal';
import { FormA } from '../../components/form';
import moment from 'moment';
import { getFormState, parseSavedData } from '../../../helpers/form';
import dayjs from 'dayjs';
import { useHistory, useLocation, useParams } from "react-router-dom";
import IosShareIcon from '@mui/icons-material/IosShare';
import PropTypes from 'prop-types';
const { Manager } = require("socket.io-client");


var advancedFormat = require('dayjs/plugin/advancedFormat')
dayjs.extend(advancedFormat)

const API_HOST = CONFIG.modules['accounts'].host




export const SwapRequests = (props) => {
    let socket;
    const [value, setValue] = useState(0);
    const [balance, setBalance] = useState(null);
    const {
        user,
        map,
    } = useSelector((state) => state.user || {});
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };



    useEffect(() => {
        if (user) {
            const manager = new Manager(CONFIG.modules['accounts'].socket, {
                reconnectionDelayMax: 10000,
                path: "/accounts"
            });

            socket = manager.socket("/common", {
                query: {
                    token: localStorage.getItem('authToken') || ''
                }
            });

            socket.on(`${user._id}-leave-balance`, ({ data }) => {
                if (data) {
                    setBalance(data)
                }

            })

        }
    }, [user])

    useEffect(() => {
        return () => {
            if (socket) {
                socket.removeAllListeners();
            }
        }
    }, [])



    return (
        <Box sx={{ width: '100%' }}>
            <List />
        </Box>
    )
}

export const List = () => {


    const { roles, user, users, Designations, Departments, Languages, Districts, map, Shifts, LeaveType } = useSelector((state) => (state.user || {}))
    const userStore = useSelector((state) => (state.user || {}))

    const history = useHistory();
    const location = useLocation()


    const [data, setData] = useState(users || [])
    useEffect(() => {
        fetchMySwapRequests()
    }, [])

    const fetchMySwapRequests = () => {
        axios.get(API_HOST + `/swap-requests-to-me`).then((resp) => {
            if (resp.data && resp.data.success) {

                setData(resp.data.data)
            } else {
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    const handleEdit = (id, status) => {

        axios.put(API_HOST + `/leave/${data[id]._id}`, {
            status
        }).then((resp) => {
            if (resp.data && resp.data.success) {
                data[id] = resp.data.data
                setData([...data])
            }
        }).catch((e) => {
            console.log(e)
        })
    }

    return (
        <>
            <ToolBar name={'Swap Requests'} />
            <Box sx={{ mt: 2 }}>
                <Grid data={data} columns={[{
                    id: '_id', label: 'For Date', minWidth: 120, format: (data, row) => {
                        return `${dayjs(row.forDate).format('Do MMM')} `
                    }
                },
                {
                    id: 'selectShift', label: 'Applied Shift', minWidth: 120, format: (data, row) => {
                        return data && data.shift ? `${map.Shifts[data.shift].name} (${dayjs(map.Shifts[data.shift].start).format('hh:mm a')}-${dayjs(map.Shifts[data.shift].end).format('hh:mm a')})` : ""
                    }
                },
                
                {
                    id: 'currentShift', label: 'Swap request From', minWidth: 120, format: (data, row) => {
                        return data && data.user ? map.users[data.user].name : ''
                    }
                },

                { id: 'description', label: 'Details', minWidth: 170 },
                { id: 'approved', label: 'Status', minWidth: 170 },
                {
                    id: 'createdAt', label: 'Application Date', minWidth: 60, format: (data, row) => {
                        return data ? dayjs(data).format('Do MMM') : ''
                    }
                },]}
                    actions={[
                        // {
                        //     name: 'Cancel',
                        //     showIf: {
                        //         key: 'approved',
                        //         values: ['Approved']
                        //     },
                        //     onClick: (id) => {

                        //         // handleEdit(id, 'Withdrawn')

                        //     }
                        // },
                        {
                            name: 'Accept',
                            showIf: {
                                key: 'approved',
                                values: ['Pending']
                            },
                            onClick: (id) => {
                                handleEdit(id, 'Approved')
                            }
                        },
                        {
                            name: 'Decline',
                            showIf: {
                                key: 'approved',
                                values: ['Pending']
                            },
                            onClick: (id) => {
                                handleEdit(id, 'Rejected')
                            }
                        }
                    ]}
                ></Grid>
            </Box>

        </>
    )
}